import {
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
} from "@angular/core";

@Component({
  selector: "app-uploadDialog",
  templateUrl: "./uploadDialog.component.html",
  styleUrls: ["./uploadDialog.component.css"],
})
export class UploadDialogComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  @Output() filesDropped = new EventEmitter();
  fileOver: boolean = false;
  files: any[] = [];

  @HostListener("dragover", ["$event"]) public onDragOver(event) {
    event.preventDefault();
    event.stopPropagation();

    console.log("drag over");
  }

  @HostListener("dragleave", ["$event"]) public onDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();

    console.log("drag leave");
  }

  @HostListener("drop", ["$event"]) public onDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.fileOver = false;
    const files = event.dataTransfer.files;

    if (files.length > 0) {
      this.files.push(files[0]);
    }

    console.log("drag leave");
  }

  onFileDropped(event) {
    for (const item of event) {
      this.files.push(item);
    }
  }

  deleteFile(fileIndex: number) {}

  fileBrowseHandler($event) {}
}
